import React from 'react'
import {actions} from 'react-redux-form'
import {toast} from 'react-toastify'
import qs from 'qs'
import irelandApi from '../irelandApi'
import store, {history} from '../store'
import ToastMessage from '../components/common/toast-message'
import {destandard, ucfirst} from "../utils/commonFunctions";

export const getProducts = (query) => (dispatch) => {
  dispatch({type: "GET_PRODUCT_LIST_PENDING"});
  const q = {
    product: query
  };
  return irelandApi.get(`/api/admin/categories?include=brands,products&${qs.stringify({q: q}, {encodeValuesOnly: true})}`)
                   .then((response) => {
                     dispatch({type: "GET_PRODUCT_LIST_FULFILLED", payLoad: response.data});
                   })
                   .catch((error) => {
                     // dispatch({type: 'GET_PRODUCT_LIST_REJECTED', payLoad: error.data})

                     Promise.reject(error);
                   })
};

export const getProduct = (id) => (dispatch) => {
  dispatch({type: "GET_PRODUCT_PENDING"});
  return irelandApi.get(`/api/admin/products/${id}`)
                   .then((response) => {
                     const data = destandard({
                       //photo: response.data.data.attributes.links.photo,
                       ...response.data.data.attributes
                     });
                     dispatch({type: "GET_PRODUCT_FULFILLED", payLoad: data});
                     store.dispatch(actions.load('deep.admin_product_save', data));
                   })
                   .catch((error) => {
                     toast.warn(<ToastMessage iconStyle="warning"
                                              message={`Unable to get product order.`}/>, {autoClose: 2000});
                     dispatch({type: 'GET_PRODUCT_REJECTED', payLoad: "error"})
                   })
};

export const getGroups = (query) => (dispatch) => {
  dispatch({ type: "GET_GROUPS_LIST_PENDING" });
  const q = {
    groups: query
  };
  return irelandApi.get(`/api/admin/products/new`)
    .then((response) => {
      dispatch({ type: "GET_GROUPS_LIST_FULFILLED", payLoad: response.data.meta });
    })
    .catch((error) => {
      // dispatch({ type: 'GET_GROUPS_LIST_REJECTED', payLoad: error.data })
      Promise.reject(error);
    })
};

export const getReplacementProducts = () => dispatch => {
  dispatch({ type: "GET_REPLACEMENT_PRODUCTS_PENDING" });

  return irelandApi.get('/api/admin/products/replacements')
    .then(response => dispatch({ type: "GET_REPLACEMENT_PRODUCTS_FULFILLED", payLoad: response.data.meta.replacement_products }))
}

export const reorderProducts = (categoryId, brandId, payLoad) => (dispatch) => {
  dispatch({type: "REORDER_PRODUCTS_FULFILLED", payLoad: {data: payLoad, categoryId: categoryId, brandId: brandId}});
  const data = {
    category_id: categoryId,
    brand_id:    brandId,
    order:       payLoad.map(item => +item.id)
  };
  return irelandApi.patch(`/api/admin/products/change_order`, {product: data})
                   .then((response) => {
                     toast.info(<ToastMessage iconStyle="info" message="Product order modified"/>, {autoClose: 2000});
                   })
                   .catch((error) => {
                     dispatch({type: 'REORDER_BRANDS_REJECTED', payLoad: error.data});
                     toast.warn(<ToastMessage iconStyle="warning"
                                              message="Unable to set product order"/>, {autoClose: 2000});
                   })
};

export const deleteProduct = (id) => (dispatch) => {
  dispatch({type: "DELETE_PRODUCT_PENDING"});
  return irelandApi.delete(`/api/admin/products/${id}`)
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success" message="Product has been deleted successfully"/>);
                     dispatch({type: "DELETE_PRODUCT_FULFILLED", payLoad: id});
                   })
                   .catch((error) => {
                     const data = {
                       ...error.response.data.errors
                     };
                     let message = "An error occured during delete product";
                     if(data.has_items){
                       message = data.has_items;
                     }
                     toast.error(<ToastMessage iconStyle="error" message={message}/>);
                     dispatch({type: 'DELETE_PRODUCT_REJECTED', payLoad: error.data});

                     return Promise.reject(data);
                   })
};

export const saveProduct = (payLoad, dispatch) => {
  dispatch({type: "SAVE_PRODUCT_PENDING"});
  let formData = new FormData();
  payLoad = removeNullFields(payLoad);

  payLoad["group_ids"] = payLoad["group_ids"].map(curr => {
    return curr.value;
  });

  if (payLoad["group_ids"].indexOf("all") > -1) {
    payLoad["all_groups"] = true;
    delete payLoad["group_ids"];
  }

  Object.keys(payLoad).forEach(key => {
    if (`${key}` == 'group_ids') {
      payLoad[key].forEach(value => {
        formData.append(`product[group_ids][]`, value)
      });
    } else {
      formData.append(`product[${key}]`, payLoad[key])
    }
  });

  const config = {
    headers: {'content-type': 'multipart/form-data'}
  };
  return irelandApi.post(`/api/admin/products`, formData, config)
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success" message="Product has been saved successfully"/>);
                     history.push('/admin/products');
                   })
                   .catch((error) => {
                     const errorData = error.response.data.errors;
                     dispatch({type: 'SAVE_PRODUCT_REJECTED', payLoad: errorData});

                     // Object.keys(errorData).forEach(field => {
                     //   toast.error(<ToastMessage iconStyle="error" message={errorData[field].map((e, key) => <div key={key}>{ucfirst(field.split('_').join(' '))} {e}</div>)}/>);
                     // });
                     return Promise.reject(errorData);
                   })
};

export const updateProduct = (id, payLoad, dispatch) => {
  dispatch({type: "SAVE_PRODUCT_PENDING"});

  payLoad = removeNullFields(payLoad);
  let formData = new FormData();

  if (payLoad["group_ids"]) {
    payLoad["group_ids"] = payLoad["group_ids"].map(curr => {
      return curr.value;
    });

    if (payLoad["group_ids"].indexOf("all") > -1) {
      payLoad["all_groups"] = true;
      delete payLoad["group_ids"];
    }
  }

  Object.keys(payLoad).forEach(key => {
    if (`${key}` == 'group_ids') {
      payLoad[key].forEach(value => {
        formData.append(`product[group_ids][]`, value)
      });
    } else if (`${key}` == 'special_reward' && payLoad[key] === null) {
      formData.append(`product[${key}]`, false);
    } else {
      formData.append(`product[${key}]`, payLoad[key])
    }
  });

  const config = {
    headers: {'content-type': 'multipart/form-data'}
  };

  return irelandApi.patch(`/api/admin/products/${id}`, formData, config)
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success" message="Product has been saved successfully"/>);
                     history.push('/admin/products');
                   })
                   .catch((error) => {
                     const errorData = error.response.data.errors;
                     dispatch({type: 'SAVE_PRODUCT_REJECTED', payLoad: errorData});
                     return Promise.reject(errorData);
                   })
};

const removeNullFields = (data) => {
  const copy = {...data};
  copy.tar = copy.tar || '';
  copy.flavour = copy.flavour || '';
  copy.nicotine = copy.nicotine || '';

  return copy;
}



// WEBPACK FOOTER //
// ./src/actions/products.js